import React, { useState, useEffect } from 'react';
import BackorderedDetails from './backordered-details.js';
import DateFormatter from '../../shims/date-formatter.js';
import Warning from "../../warning";
import "./sass/pick-up-details.scss";

function PickupDetails({
	details,
	handleToggle,
	needMoreShown,
	fulfillmentDetails,
	pricingDetails
}) {
	const checkNearByStoresLink =
			<a href="#" className="u__default-link store-inventory-finder-trigger">
				Check Nearby Stores
			</a>;

	const { aisle, bay, store, type, nearbyStore, bossDominant, secondaryBuyOnlineShipToStore} = details;
	const {isBossBopisSharedTile, quantityError} = fulfillmentDetails;
	const { itemOnSale, specialPrice, originalPrice, bopisThresholdTotal, bopisThresholdStores } = pricingDetails;
	const displayedPrice = itemOnSale ? specialPrice : originalPrice;
	const quantityBoxSelectorInput = window.$("#buybox__quantity__input");
	const [totalPrice, setTotalPrice] = useState(displayedPrice);

	useEffect(() => {
		window.$(document).click(function (ev) {
			if (ev.target.id === "buybox__quantity__input" || ev.target.classList.contains("quantity-btn")) {
				setTotalPrice(displayedPrice*quantityBoxSelectorInput.val());
			}
		});
		window.$(quantityBoxSelectorInput).change(function () {
			setTotalPrice(displayedPrice*quantityBoxSelectorInput.val());
		});
		window.$(quantityBoxSelectorInput).ready(function () {
			setTotalPrice(displayedPrice*quantityBoxSelectorInput.val());
		});
	},[quantityBoxSelectorInput.val()]);

  	const showNeedMore = () => {
		return (bossDominant && secondaryBuyOnlineShipToStore && !fulfillmentDetails.isOosAtOnline);
	}
	  
	const isBopisThresholdStore = (storeWithInventory) => {
		return (pricingDetails && bopisThresholdStores ?
			bopisThresholdStores.indexOf(storeWithInventory) !== -1 : false);
	}

	const isBopisMinimumTotal = (totalPrice) => {
		const bopisMinimum = pricingDetails &&  bopisThresholdTotal ? bopisThresholdTotal : 0;
		return totalPrice >= bopisMinimum;
	}

	const bopisThresholdMessaging = () => {
		return (
		<span>There's a ${bopisThresholdTotal} minimum purchase for pickup.</span>
		)
	}

	const bopis2pmCutoffMessaging = () => {
		return (
			<span>Due to order volume, this item may not be available for pickup until <span className="u__bold">tomorrow.</span></span>
		)
	}

	let storeName = store ? store.storeName : "NOT LOCALIZED";

	if (type === "BOPIS") {
		let quantity = store.quantity;
		let storeNumber = store.storenumber;
		if (quantity > 0 && !store.isUnavailable) {
			return (
				<div className="heading-message store_pickup_section">
					<span className="dai_detailsMessage">
						<span className="store-box__store-quantity u__bold">
							<span className="u__text--success quantity">{quantity}&nbsp;</span>
						</span>
						in stock at&nbsp;
						<span className="store-box__store-quantity u__bold">
							{storeName}.
						</span>
					</span>
					{showNeedMore() && (
						<a className="u__default-link dai_needMoreLink" onClick={handleToggle}>
							Need More?
						</a>
					)}
					<div>
						{!needMoreShown && checkNearByStoresLink}
					</div>
					{isBopisThresholdStore(storeNumber) && !isBopisMinimumTotal(totalPrice) && (
						<Warning>
							{bopisThresholdMessaging()}
							{fulfillmentDetails.showBopisCovidAlert && (
								<div className="body__m-top-small">{bopis2pmCutoffMessaging()}</div>
							)}
						</Warning>
					)}
					{isBopisThresholdStore(storeNumber) && isBopisMinimumTotal(totalPrice) &&
						fulfillmentDetails.showBopisCovidAlert && (
						<Warning>
							{bopis2pmCutoffMessaging()}
						</Warning>
					)}
					{!isBopisThresholdStore(storeNumber) &&
						fulfillmentDetails.showBopisCovidAlert && (
						<Warning>
							{bopis2pmCutoffMessaging()}
						</Warning>
					)}
				</div>
			);
		} else {
			let nearbyQuantity = nearbyStore ? nearbyStore.quantity : 0;
			let nearbyStoreNumber = nearbyStore ? nearbyStore.storeId : false;
			if (nearbyQuantity > 0) {
				let nearbyStoreName = nearbyStore ? nearbyStore.name : "NOT LOCALIZED";
				let distance = nearbyStore ? ("(" + nearbyStore.distance + " mi away)") : "";
				return (nearbyQuantity ?
					<div className="heading-message store_pickup_section">
						<div className="store-box__store-quantity warning_text dai_detailsMessage">
							Not in stock at {storeName}.
						</div>
						<div className="heading-message store_pickup_section" />
						<span className="dai_detailsMessageNearby">
							<div className="store-box__store-quantity u__bold">
								<span className="u__text--success quantity">{nearbyQuantity}&nbsp;</span>
							</div>
							in stock at&nbsp;
							<div className="store-box__store-quantity u__bold">
								{nearbyStoreName}&nbsp;
							</div>
							{distance}.
						</span>
						<div>
							{checkNearByStoresLink}
						</div>
						{aisle && bay && !nearbyStore &&
						<div className="u--paddingTop">
							<span className="u__bold contentSpacing">{`Aisle ${aisle}, Bay ${bay} `}</span>
							<a id="aisleBayTooltipOpener" rel="nofollow" href="/p/svcs/taab"
							   className="u__default-link">
								Text to Me
							</a>
						</div>}
						{isBopisThresholdStore(nearbyStoreNumber) && !isBopisMinimumTotal(totalPrice) && (
							<Warning>
								{bopisThresholdMessaging()}
								{fulfillmentDetails.showBopisCovidAlert && (
									<div className="body__m-top-small">{bopis2pmCutoffMessaging()}</div>
								)}
							</Warning>
						)}
						{isBopisThresholdStore(nearbyStoreNumber) && isBopisMinimumTotal(totalPrice) &&
							fulfillmentDetails.showBopisCovidAlert && (
							<Warning>
								{bopis2pmCutoffMessaging()}
							</Warning>
						)}
						{!isBopisThresholdStore(nearbyStoreNumber) &&
							fulfillmentDetails.showBopisCovidAlert && (
							<Warning>
								{bopis2pmCutoffMessaging()}
							</Warning>
						)}
					</div> : null
				);
	 		}
			else if(!(nearbyQuantity===0 && nearbyStore && nearbyStore.isLimitedQuantity)){
	 			return (
					<div className="heading-message dai_detailsMessage">
						<span className="u__text--danger">Unavailable</span> at {storeName} &nbsp;
						{checkNearByStoresLink}
					</div>
				);
			}

		}

	} else {
		if(bossDominant && isBossBopisSharedTile && quantityError){
			let quantity = store ? store.quantity : null;
			let nearbyQuantity = nearbyStore ? nearbyStore.quantity : 0;
			let nearbyStoreName = nearbyStore ? nearbyStore.name : "";

			let displayQuantity = quantity;
			let displayStore = storeName;
			if(!quantity && nearbyQuantity && nearbyStoreName){
				displayQuantity = nearbyQuantity;
				displayStore = nearbyStoreName;
			}

			let dateRange = details.rawEstimatedStartDeliveryDate !== details.rawEstimatedEndDeliveryDate;
			let expectItDate = dateRange? DateFormatter.convertLongMonthToShort(details.estimatedStartDeliveryDate) + ' - ' +
				DateFormatter.convertLongMonthToShort(details.estimatedEndDeliveryDate) : "";
			return (
				<div>
					<div className="boss-dominant-warning-boss">
					<Warning >
						<span >&nbsp;{displayStore} only has </span>
						<span className='u__bold'>{displayQuantity}</span>
						<span> in stock.</span>
					</Warning>
					</div>
					<div className="u--paddingTop store_pickup_section dai_detailsMessage">
						We'll ship the quantity you need to &nbsp;
						<div className="store-box__store-quantity u__bold">
								{storeName} &nbsp;
						</div>
						for <span className="boss-quantity">free pickup &nbsp;</span>
						<span className="u__bold">{expectItDate}.</span>
					</div>
					<div>
					<a href="#" className="u__default-link store-inventory-finder-trigger">Change Store</a>
					</div>
				</div>
			);
		}else{
			return (
				<div>
					<div className="heading-message store_pickup_section dai_detailsMessage">
						We'll send it to &nbsp;
						<div className="store-box__store-quantity u__bold">
								{storeName} &nbsp;
						</div>
						for <span className="u__text--success quantity">free pickup.</span> &nbsp;
						<div>
							<a href="#" className="u__default-link store-inventory-finder-trigger">Change Store</a>
						</div>
					</div>
					<BackorderedDetails
						details={details}
						expectItDate={details.estimatedStartDeliveryDate}
					/>
				</div>
			);
		}

	}
}

export default PickupDetails;
